import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(3),
  },
  normalRow: {
    transition: "background-color 150ms ease",
    "&:hover": {
      backgroundColor: `${theme.palette.primary.main}0F`,
    },
  },
  highlightedRow: {
    backgroundColor: `${theme.palette.primary.main}1F`,
    transition: "background-color 150ms ease",
  },
  expandedParentRow: {
    backgroundColor: `${theme.palette.primary.main}05`,
    "& td:first-child": {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
    },
  },
  dateCellContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  expandIcon: {
    display: "inline-flex",
    alignItems: "center",
    color: theme.palette.grey[400],
    transition: "transform 200ms ease, color 150ms ease",
    flexShrink: 0,
  },
  expandIconOpen: {
    transform: "rotate(90deg)",
    color: theme.palette.primary.main,
  },
  ispRow: {
    backgroundColor: "#F9FAFB",
    transition: "background-color 150ms ease",
    "&:hover": {
      backgroundColor: "#F3F4F6",
    },
    "& td:first-child": {
      borderLeft: `3px solid ${theme.palette.primary.main}66`,
    },
  },
  ispRowLast: {
    "& td": {
      borderBottom: "none",
    },
  },
  ispClosingRow: {
    backgroundColor: "#F9FAFB",
    "& td": {
      borderBottom: `3px solid ${theme.palette.primary.main}66`,
      borderLeft: `4px solid ${theme.palette.primary.main}`,
    },
  },
  opensStart: {
    backgroundColor: "#F0FDF4",
    borderLeft: "2px solid #86EFAC",
  },
  opensEnd: {
    backgroundColor: "#F0FDF4",
    borderRight: "2px solid #86EFAC",
  },
  clicksStart: {
    backgroundColor: "#ECFDF5",
    borderLeft: "2px solid #6EE7B7",
  },
  clicksEnd: {
    backgroundColor: "#ECFDF5",
    borderRight: "2px solid #6EE7B7",
  },
  ispOpensStart: { borderLeft: "2px solid #86EFAC" },
  ispOpensEnd: { borderRight: "2px solid #86EFAC" },
  ispClicksStart: { borderLeft: "2px solid #6EE7B7" },
  ispClicksEnd: { borderRight: "2px solid #6EE7B7" },
}));

export type StyleClasses = ReturnType<typeof useStyles>;

export function getHighlightClass(
  highlight: string | undefined,
  classes: StyleClasses
): string | undefined {
  if (highlight === "opens-start") return classes.opensStart;
  if (highlight === "opens-end") return classes.opensEnd;
  if (highlight === "clicks-start" || highlight === "spam-start")
    return classes.clicksStart;
  if (highlight === "clicks-end" || highlight === "spam-end")
    return classes.clicksEnd;
  return undefined;
}

export function getIspHighlightClass(
  highlight: string | undefined,
  classes: StyleClasses
): string | undefined {
  if (highlight === "opens-start") return classes.ispOpensStart;
  if (highlight === "opens-end") return classes.ispOpensEnd;
  if (highlight === "clicks-start" || highlight === "spam-start")
    return classes.ispClicksStart;
  if (highlight === "clicks-end" || highlight === "spam-end")
    return classes.ispClicksEnd;
  return undefined;
}
